import { createAsyncThunk } from '@reduxjs/toolkit';
import alertApi from '~/apis/alert';
import { GET_ADMIN_ALERTS } from '~/utils/constants/actionType';
import { IParamsAlert, IResponseGetListAlert } from '~/utils/interface/alert';

export const handleGetAlertList = createAsyncThunk<IResponseGetListAlert, IParamsAlert>(
  GET_ADMIN_ALERTS,
  async (params: IParamsAlert = {}, { rejectWithValue }) => {
    try {
      const response = await alertApi.getAlerts(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
